const IDENTITY_CENTRALIZED = "identityCentralized";
const SELECTED_FEDERATED_PROVIDER = "selectedFederatedProvider";

interface LocalStorageHandler {
  setter: (value: string) => void;
  getter: () => string | null;
  clearer: () => void;
}

function createLocalStorageHandler(key: string): LocalStorageHandler {
  const setter = (value: string) => localStorage.setItem(key, value);
  const getter = () => localStorage.getItem(key);
  const clearer = () => localStorage.removeItem(key);

  return { setter, getter, clearer };
}

export const {
  setter: setIdentityCentralized,
  getter: getIdentityCentralized,
  clearer: clearIdentityCentralized,
} = createLocalStorageHandler(IDENTITY_CENTRALIZED);

export const {
  setter: setSelectedFederatedProvider,
  getter: getSelectedFederatedProvider,
  clearer: clearSelectedFederatedProvider,
} = createLocalStorageHandler(SELECTED_FEDERATED_PROVIDER);
